import { FunctionComponent, Suspense } from "react";
import { createUseStyles } from "react-jss";

import { puspenerbalBackgroundMapImage } from "assets/images";
import { BasicTheme, COLORS } from "assets/theme";

import LoaderPage from "components/atoms/Loader/LoaderPage/LoaderPage";
import Sidebar from "components/Sidebar/Sidebar";
import { SidebarItemProps } from "components/Sidebar/SidebarItem";

interface Props {
  sidebarItems: SidebarItemProps[];
}

const useStyles = createUseStyles((_: BasicTheme) => {
  return {
    container: {
      display: "flex",
      flexDirection: "row",
      minHeight: "100vh",
      backgroundColor: COLORS.navyGreen,
      backgroundImage: `url(${puspenerbalBackgroundMapImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    },
    sidebar: {
      flexBasis: "230px",
      maxHeight: "100vh",
      display: "flex",
    },
    outlet: {
      flex: 1,
      maxHeight: "100vh",
      overflowY: "auto",
    },
  };
});

const Layout: FunctionComponent<Props> = ({ sidebarItems, children }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Sidebar sidebarItems={sidebarItems} />
      <div className={classes.outlet}>
        {/**
         * @todo add new loading fallback here
         */}
        <Suspense fallback={<LoaderPage />}>{children}</Suspense>
      </div>
    </div>
  );
};

export default Layout;
